module.exports = __webpack_public_path__ + "img/gemaelde1.cd713fea.jpg";